import { render, staticRenderFns } from "./LeavingForm.vue?vue&type=template&id=12ac638e&"
import script from "./LeavingForm.vue?vue&type=script&lang=js&"
export * from "./LeavingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports